export default __webpack_public_path__ + "static/media/modal1.3a050a38.jpg";